import { Avatar } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './index.module.scss'
import { formatCommonAmount } from '../../../util/formatAmount'
const cardStatusMap = {
		// Completed: 'completed',
		// Accepted: 'in-progress',
		// Rejected: 'declined',
		// pending: 'pending',
		recieved: 'pending',
	}
export default function CardView({
	kazoo,
	handleClick,
	handleAcceptClick,
	handleRejectClick,
}) {
	// 🔹 Map status to SCSS class
	const cardStatusClass = cardStatusMap[kazoo.status] || ''

	return (
		<div className={styles.cardView}>
			{/* Header */}
			<div className={styles.cardHead}>
				<div className={styles.cardHeadLeft}>
					<figure className={styles.cardImage}>
						<Avatar src={kazoo.image} alt={kazoo.kazooName} />
					</figure>
					<div className={styles.cardHeadText}>
						<h2>{kazoo.kazooName}</h2>
						<div className={styles.cardHeadTextSub}>
							<p>
								<img
									src="/images/calendar.svg"
									alt="Calendar"
								/>{' '}
								<span>{kazoo?.startDate?.slice(0, 10)}</span>
							</p>
							<p>
								<img
									src="/images/TotalGuests.svg"
									alt="TotalGuests.svg"
								/>{' '}
								<span>{kazoo.guestCount}</span>
							</p>
						</div>
					</div>
				</div>
			</div>

			{/* Body */}
			<div className={styles.cardBodyMain}>
				<div className={styles.cardBody}>
					<div className={styles.vendorAndVenue}>
						<ButtonCustom variant="outlined" size="sm">
							<img
								src="/images/venues-icn.svg"
								alt="venues-icn.svg"
							/>
							Venues
							<b>{kazoo.venues}</b>
						</ButtonCustom>
						<ButtonCustom variant="outlined" size="sm">
							<img src="/images/buliding.svg" alt="buliding" />
							Vendors
							<b>{kazoo.vendors}</b>
						</ButtonCustom>
					</div>
				</div>

				{/* Footer */}
				<div className={styles.cardFooter}>
					<div className={styles.cardFooterBtn}>
						{kazoo.status === 'recieved' ? (
							<>
								<ButtonCustom
									data-cy="confirm-wedding"
									variant="approve"
									size="lg"
									onClick={() => handleAcceptClick(kazoo._id)}
								>
									Accept
								</ButtonCustom>
								<ButtonCustom
									data-cy="reject-wedding"
									variant="destructive"
									size="lg"
									onClick={() => handleRejectClick(kazoo._id)}
								>
									Decline
								</ButtonCustom>
							</>
						) : (
							<>
								<p>
									Budget:
									{formatCommonAmount(kazoo?.budget)}
								</p>
								<ButtonCustom
									data-cy="viewdetail"
									variant="outlined"
									size="md"
									onClick={() =>
										handleClick(kazoo._id, kazoo.status)
									}
								>
									View Detail
								</ButtonCustom>
							</>
						)}
					</div>
				</div>
			</div>

			{/* Status */}
			{kazoo.status && (
				<div
					className={`${styles.cardStatus} ${
						styles[cardStatusClass]
					}`}
				>
					<p>{cardStatusClass}</p>
				</div>
			)}
		</div>
	)
}
